import { Link } from "react-router-dom";
import { usePageSeo } from "@/context/SiteContext";

export default function NotFoundPage() {
  usePageSeo("Page Not Found");
  return (
    <div className="pt-20 min-h-screen bg-background flex flex-col items-center justify-center gap-5 px-4 text-center" data-testid="not-found-page">
      <p className="font-display text-7xl font-black text-primary">404</p>
      <h1 className="font-display text-2xl font-bold uppercase text-foreground">Page Not Found</h1>
      <p className="text-zinc-400 max-w-md">The page you are looking for does not exist or has been moved.</p>
      <Link to="/" className="btn-themed" data-testid="not-found-home-link">
        Back to Home
      </Link>
    </div>
  );
}
